var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashSolidB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03457 0.483984L4.80957 0.875H1.80957C1.25645 0.875 0.80957 1.26602 0.80957 1.75C0.80957 2.23398 1.25645 2.625 1.80957 2.625H13.8096C14.3627 2.625 14.8096 2.23398 14.8096 1.75C14.8096 1.26602 14.3627 0.875 13.8096 0.875H10.8096L10.5846 0.483984C10.4158 0.185938 10.0689 0 9.69082 0H5.92832C5.5502 0 5.20332 0.185938 5.03457 0.483984ZM13.8096 3.5H1.80957L2.47207 12.7695C2.52207 13.4613 3.17832 14 3.96895 14H11.6502C12.4408 14 13.0971 13.4613 13.1471 12.7695L13.8096 3.5Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSolidB);
export default __webpack_public_path__ + "static/media/trash-solid-b.0bc3a4cae063c281bf14d31ab86946e9.svg";
export { ForwardRef as ReactComponent };